import { getYandexMetrikaClientId } from "@/utils/analytics";
import { useEffect, useState } from "react";

export const useYandexMetrikaClientId = () => {
  const [id, setId] = useState<string | undefined>(undefined);
  useEffect(() => {
    getYandexMetrikaClientId().then((id?: string) => setId(id));
  }, []);
  return id;
};
